import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { StepsModule } from 'primeng/steps';
import { MenuItem } from 'primeng/api';
import { FileUploadModule } from 'primeng/fileupload';
import { Router } from '@angular/router';
import { StoreService } from '../store.service';
import { ApiService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpHeaders, HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import Swal from 'sweetalert2';
import { Message, ConfirmationService } from 'primeng/primeng';


@Component({
  selector: 'app-doc-upload',
  templateUrl: './doc-upload.component.html',
  styleUrls: ['./doc-upload.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ApiService, ConfirmationService]
})
export class DocUploadComponent implements OnInit {
  msgs: Message[] = [];
  steps: MenuItem[];
  activeIndex: number = 1;
  uploadedFiles: any[] = [];
  value: number = 0;
  postDocApiUrl: string;
  totalFiles: number = 0;
  indexOfFileInProgress: number = 0;
  progress: any;
  Scanning: any;
  connectCompanyMessage: string= "";
  clientFiles:any=[];
  fileIndex:number = 0;
  subscribedPlan:any = {};
  totalTrialPdf:any = 100;
  loadingMessage: any = "Loading...";
  totalDocumentProcessed:any=[];
  AsyncBackEndScanning:boolean=false;
  DirectPostfromEmail:boolean=false;
  directPostInvoices:any=[];
  qboResponse: any = [];
  documentIds:string[]=[];
  dialogEditVisible: boolean = false;
  leftTrailDays:any = 0;
  constructor(private router: Router, private store: StoreService, private http: HttpClient, private api: ApiService, private spinner: NgxSpinnerService,private confirmationService: ConfirmationService) {
    //location.reload();
    //http://localhost:61457/api/scan/UploadDocumentQbo?sessionID=12312
    this.postDocApiUrl = api.apiBaseUrl + "scan/UploadDocumentQbo?sessionID=1"

  }

  validateConnectCompany() {
    var companyName = this.store.fetchCompanyName();
    if (companyName == '' || companyName == null) {
      this.connectCompanyMessage = "No company is connected, Connect a company from Switch Company menu";
    }
  }

  ngOnInit() {
    this.store.storePageName('/docupload');
    this.validateConnectCompany();

    this.getRahDetail();

    this.getSubscribedPlan();
    this.steps = [
      {
        label: 'Map Supplier Default Account',
        command: (event: any) => {
          this.store.storePageName('/mapaccount');
          this.activeIndex = 0;
          this.router.navigateByUrl('/mapaccount');
        }
      },
      {
        label: 'Upload Document',
        command: (event: any) => {
          this.store.storePageName('/docupload');
          this.activeIndex = 1;
          this.router.navigateByUrl('/docupload');
        }
      },
      {
        label: 'Review and Approve',
        command: (event: any) => {
          this.store.storePageName('/docreview');
          this.activeIndex = 2;
          this.router.navigateByUrl('/docreview');
        }
      },
      {
        label: 'Post To Accounting System',
        command: (event: any) => {
          this.store.storePageName('/docpost');
          this.activeIndex = 3;
          this.router.navigateByUrl('/docpost');
        }
      }
    ];


  }

  getRahDetail(){
    this.api.get('Rah/GetByAccountID', '').subscribe(
      (res: {}) => this.sucessQboMaster(res),
      error => this.failedQboMaster(<any>error));
  }

  failedQboMaster(res: any) {
    this.spinner.hide();
  }
  
  sucessQboMaster(res: any) {
    this.spinner.hide();
    if (res.StatusCode == 0) {

      var companyName = res.Data[0].CompanyName;
      if (companyName == '' || companyName == null) {
        this.connectCompanyMessage = "No company is connected, Connect a company from Switch Company menu";
      }
      this.AsyncBackEndScanning=res.Data[0].AsyncBackEndScanning;
      this.DirectPostfromEmail=res.Data[0].DirectPostfromEmail
    }
  }

  getSubscribedPlan() {
    this.api.get('Plan/GetAccountSubscribedPlan', '').subscribe(
      (res: {}) => this.sucessGetSubscribedPlan(res),
      error => this.failedGetSubscribedPlan(<any>error));
  }

  sucessGetSubscribedPlan(res: any) {
    this.subscribedPlan = res.Data;
    console.log('subscribedPlan');
    console.log( this.subscribedPlan);
    this.leftTrailDays = this.subscribedPlan.LeftTrailDays;
    this.getTotalTrialPdfUsed();
    
  }

  failedGetSubscribedPlan(res: any) {
    
  }

  
  getTotalTrialPdfUsed() {
    this.api.get('Plan/GetTotalTrialPdfUsed', '').subscribe(
      (res: {}) => this.sucessGetTotalTrialPdfUsed(res),
      error => this.failedGetTotalTrialPdfUsed(<any>error));
  }

  sucessGetTotalTrialPdfUsed(res: any) {
    if (res.Data != null) {
      if(!this.subscribedPlan.IsPaidPlan){
        this.totalTrialPdf =this.subscribedPlan.CurrentAllocatePDF - res.Data.TotalPaidUsedOnCurrentSubscription;
        
      }

      if(this.subscribedPlan.IsPaidPlan){

        this.totalTrialPdf = this.subscribedPlan.CurrentAllocatePDF - res.Data.TotalPaidUsedOnCurrentSubscription;

      }

      console.log('totalTrialPdf');
    console.log( this.totalTrialPdf);
    }


    
  }

  failedGetTotalTrialPdfUsed(res: any) {
    
  }

  onUpload(event) {

    
    this.totalFiles = 0;
    this.spinner.hide();

    for (let file of event.files) {

      this.uploadedFiles.push(file);
    }

    // this.router.navigateByUrl('/docreview');
    //this.messageService.add({severity: 'info', summary: 'File Uploaded', detail: ''});
  }

  onBeforeSend(event) {
    //Not being triggred
  
  console.log("BeforeSend");
    var qboConnectID = this.store.fetchQboConnectID();
    var token = this.store.fetchToken();

    event.xhr.setRequestHeader("CosmicBill-UserToken", token);
    event.xhr.setRequestHeader("CosmicBill-QboConnectID", qboConnectID);
    event.xhr.setRequestHeader("CosmicBill-PlatformID", '2');

   

  }

  onProgress(event) {
    //Not being triggred
  }

  onSelect(event) {

     this.getSubscribedPlan();
      if ( (event.files.length +this.fileIndex) > this.totalTrialPdf ) {
        console.log("this.totalFiles > availableTotalPdfCount" + this.totalTrialPdf);
        this.msgs = [];
        this.msgs.push({ severity: 'Info', summary: 'Please send email to upgrade your plan: support@cosmicbills.com', detail: 'You have available( ' + this.totalTrialPdf + ') pdfs cannot exceed the limit .' });
        this.uploadedFiles = [];
        this.totalFiles = 0;
        this.uploadedFiles = [];
        this.fileIndex = 0;
        this.indexOfFileInProgress = 1;
        this.totalDocumentProcessed=[];
        
        return;
      }
    



    this.indexOfFileInProgress = 1;
    this.totalFiles = this.totalFiles + event.files.length;
    this.loadingMessage= "Processing "+this.indexOfFileInProgress+" / " +this.totalFiles;
    for (let file of event.files) {
      this.fileIndex++
      this.uploadedFiles.push( {myfile: file, fileId:this.fileIndex, ScanInvoiceID:0,DocumentID:0, status:0,progressMessage:''});
    }
  }

  myUploader(event) {
    this.documentIds=[];
    if (this.uploadedFiles.length > this.totalTrialPdf) {
        console.log("this.totalFiles > availableTotalPdfCount" + this.totalTrialPdf);
        this.msgs = [];
        this.msgs.push({ severity: 'Info', summary: 'Please send email to upgrade your plan: support@cosmicbills.com', detail: 'You have available( ' + this.totalTrialPdf + ') pdfs cannot exceed the limit .' });
        this.uploadedFiles = [];
        this.totalFiles = 0;

        return;
      }
    this.uploadedFiles.forEach(element => {
      console.log('element'+element);
      console.log('element'+element.myfile);
      console.log('element'+element.myfile.name);
      element.progressMessage = "Uploading...";
      this.upload(element);
    });
  }

  async uploadDocument(element) {




    element.status = 1;
    console.log(this.indexOfFileInProgress);
    //this.spinner.show();

    const formData = new FormData();
    formData.append(element.fileId, element.myfile);

    const uploadHdr = this.getHeader();

    const uploadReq = new HttpRequest('POST', this.postDocApiUrl, formData, {
      headers: uploadHdr
     

    });

    
   
    var asyncResult= this.http.request(uploadReq).toPromise();
    console.log(asyncResult);

    //this.sucessUpload(asyncResult);
    // this.http.request(uploadReq).subscribe(
    //   (res: {}) => this.sucessUpload(res),
    //   error => this.failedUpload(<any>error));

  }

  upload(element) {
  
    element.status = 1;
    console.log(this.indexOfFileInProgress);
    this.spinner.show();

    const formData = new FormData();
    formData.append(element.fileId, element.myfile);

    const uploadHdr = this.getHeader();

    const uploadReq = new HttpRequest('POST', this.postDocApiUrl, formData, {
      headers: uploadHdr
     

    });

    this.http.request(uploadReq).subscribe(
      (res: {}) => this.sucessUpload(res),
      error => this.failedUpload(<any>error));
  }

  getHeader(): any {
    let qboConnectID = this.store.fetchQboConnectID();
    let token = this.store.fetchToken();

    return new HttpHeaders(
      {
        'CosmicBill-UserToken': token.toString(),
        'CosmicBill-QboConnectID': qboConnectID.toString(),
        'CosmicBill-PlatformID': '2',

      }
    );
  }


  sucessUpload(resp: any) {

    console.log('resp');
    console.log(resp);
    if (resp != null) {
      if (resp.body != null) {
        if (resp.body.StatusCode === 0) {
          if(this.AsyncBackEndScanning==true || this.DirectPostfromEmail==true){

          var myfile = this.uploadedFiles.find(ff=> ff.fileId == resp.body.Data[0].ClientFileID);
          if(myfile != null){
            myfile.ScanInvoiceID = resp.body.Data[0].ScanInvoiceID;
            myfile.DocumentID = resp.body.Data[0].DocumentID;
            this.totalDocumentProcessed.push(resp.body.Data[0].DocumentID);
            //myfile.status = 2
            //myfile.progressMessage = "Scanning...";
            //look for scan invoice id
          //  this.scanDocument(resp.body.Data[0]);
            myfile.status = 3
            myfile.progressMessage = "Upload Completed.";
            this.indexOfFileInProgress = this.indexOfFileInProgress + 1;
            this.loadingMessage= "Processing "+this.indexOfFileInProgress+" / " +this.totalFiles;

            if ((this.indexOfFileInProgress - 1) == this.totalFiles) {
        
              this.indexOfFileInProgress = this.indexOfFileInProgress - 1;
               this.loadingMessage= "Processing "+this.indexOfFileInProgress+" / " +this.totalFiles;

              setTimeout(() => {
              
                this.insertQboJob(this.totalDocumentProcessed.toString())
                
               
              }, 1000);
        
            }

          }
        }else{
          var myfile = this.uploadedFiles.find(ff=> ff.fileId == resp.body.Data[0].ClientFileID);
          if(myfile != null){
            myfile.ScanInvoiceID = resp.body.Data[0].ScanInvoiceID;
            myfile.DocumentID = resp.body.Data[0].DocumentID;
            
            myfile.status = 2
            myfile.progressMessage = "Scanning...";
            //look for scan invoice id
            this.scanDocument(resp.body.Data[0]);
           

          }
        }
        }
      }
    }

  
  }

  insertQboJob(documentIDs:any){
    this.api.get('Scan/InsertQboJob?documentIDs=',documentIDs.toString()).subscribe(
      (res: {}) => this.successInsertQboJob(res),
      error => this.failedInsertQboJob());
  }
  successInsertQboJob(resp:any){
    if(resp.StatusCode==0){
    this.spinner.hide();
    if(this.DirectPostfromEmail==true){
      Swal.fire('','No need to wait!..\n We will scan & post the bills and notify you by the email.You will then see your bills in Reckon Account as you have selected \'No need to approve Post to RAH\' in MyProfile','info');
    }else 
       Swal.fire('','No need to wait!..\n We will scan the bills and notify you by the email.You will then approve at step 3 and post the bills at process 4','info');
    if(this.uploadedFiles != null)
      this.uploadedFiles = [];

    this.fileIndex = 0;
    this.indexOfFileInProgress = 1;
    this.totalFiles = 0;
    this.totalDocumentProcessed=[];
    this.router.navigateByUrl('/docreview');
  }
  }
  failedInsertQboJob(){
    this.spinner.hide();

  }

  failedUpload(resp: any) {
    console.log(resp);
    this.spinner.hide();
    if(resp.status == 401)
    {
      this.router.navigateByUrl('/logout');
    }
  }

  
  scanDocument(document: any) {

    this.spinner.show();
    this.api.post('Scan/ScanQboDocument', document).subscribe(
      (res: {}) => this.sucessScanDocument(res),
      error => this.failedScanDocument(<any>error));

  }

  sucessScanDocument(resp: any) {
    console.log('sucessScanDocument' + resp);
    if (resp != null) {

      if (resp.Data != null) {
        console.log('sucessScanDocument status' + resp.StatusCode);
        if (resp.StatusCode == 0) {

          this.documentIds.push(resp.Data.DocumentID);

          //Getting File uploaded object
          var myfile = this.uploadedFiles.find(ff=> ff.ScanInvoiceID == resp.Data.ScanInvoiceID);
          if(myfile != null){
            
            this.directPostInvoices.push(resp.Data);
            myfile.status = 3
            myfile.progressMessage = "Scanning Completed.";
           
          }


          this.indexOfFileInProgress = this.indexOfFileInProgress + 1;
          this.loadingMessage= "Processing "+this.indexOfFileInProgress+" / " +this.totalFiles;


          if ((this.indexOfFileInProgress - 1) == this.totalFiles) {

            this.indexOfFileInProgress = this.indexOfFileInProgress - 1;

              this.spinner.hide();
             
              if(this.DirectPostfromEmail==true){
               
                    this.spinner.show();
                    this.loadingMessage = "Posting to RAH...";
                    this.api.post('Rah/CreateBillDocuments', this.directPostInvoices).subscribe(
                      (res1: {}) => this.successCreateBill(res1),
                      error => this.failedCreateBill(<any>error));
            
              }else{
                // send mail about scanning manually                
                 this.api.post('Scan/SendMailAfterScanManually', { DocumentIDs:this.documentIds}).subscribe(
                  (res: {}) => console.log(res),
                    error => console.log(error));

                this.router.navigateByUrl('/docreview');
              }

          }
          else{console.log("setTimeout")}
        }

      }
    }

  }
  successCreateBill(resp: any) {
    this.spinner.hide();
    if(this.uploadedFiles != null)
    this.uploadedFiles = [];

    this.fileIndex = 0;
    this.indexOfFileInProgress = 1;
    this.totalFiles = 0;
    this.totalDocumentProcessed=[];

    this.dialogEditVisible = false;
    this.openRespWindow(resp);
  }

  openRespWindow(resp: any) {
    resp.Data.forEach(element => {
      this.qboResponse.push(
        {
          'InvoiceNo': element.InvoiceNo,
          'Supplier': element.Supplier,
          'ReponseFromXero': element.ReponseFromXero,
          'ErrorMessage': element.ErrorMessage
        });
    });

    this.dialogEditVisible = true;
  }

  sucess(resp: any) {
    console.log(resp);

  }

  failed(resp: any) {
    console.log(resp);

  }

  failedCreateBill(resp: any) {
    this.spinner.hide();

    if(this.uploadedFiles != null)
     this.uploadedFiles = [];

    this.fileIndex = 0;
    this.indexOfFileInProgress = 1;
    this.totalFiles = 0;
    this.totalDocumentProcessed=[];

  }

  failedScanDocument(resp: any) {
    console.log("failed Scan document");
    console.log(resp);
    this.spinner.hide();
   
  }


  clearAll(event){
    
    if(this.uploadedFiles != null)
      this.uploadedFiles = [];

      this.fileIndex = 0;
      this.indexOfFileInProgress = 1;
      this.totalFiles = 0;
      this.totalDocumentProcessed=[];
  }

  removeFile(my:any){
    const index: number = this.uploadedFiles.indexOf(my);
    if (index !== -1) {
        this.uploadedFiles.splice(index, 1);

    if(this.uploadedFiles.length == 0){
      
      this.clientFiles = [];
      this.fileIndex = 0;
      this.indexOfFileInProgress = 1;
      this.totalFiles = 0;
    }

    }  
  }



}

